<template>
  <div
    id="app"
    class="page-wrapper"
  >
    <main>
      <LauncherHeader />
      <div
        id="launcher"
        class="uk-container uk-container-small uk-container-center"
      >
        <progress
          v-if="!error"
          id="js-progressbar"
          class="uk-progress"
          v-bind:value="progress"
          max="100"
        ></progress>
        <div
          v-if="forwardurl"
          class="uk-alert-success"
          uk-alert
        >You will now be forwarded to your new WebMo at {{forwardurl}}</div>
        <div
          class="uk-alert-danger"
          uk-alert
          v-if="error"
        >
          <!-- <a
            class="uk-alert-close"
            uk-close
          ></a> -->
          <h3>{{error.reason}} ({{error.code}})</h3>
          <p>{{error.message}}</p>
          <button
            v-if="error.retry"
            @click="onRetry"
            class="uk-button uk-button-default uk-button-small"
          >Retry</button>
        </div>
      </div>
    </main>
    <LauncherFooter />
  </div>
</template>

<script>
import LauncherHeader from "./components/LauncherHeader.vue";
import LauncherFooter from "./components/LauncherFooter.vue";
import WebSocketClient from "./js/webSocketClient.js";

export default {
  name: "app",

  components: {
    LauncherHeader,
    LauncherFooter
  },

  data: function () {
    return {
      step: 0,
      error: null,
      progress: 0,
      forwardurl: false,
      events: [],
      currentEvent: null,
      isActive: function (event) {
        //console.log(event.statusMessage == this.currentEvent.statusMessage);
        return event == this.currentEvent;
      },
      domain: ""
    };
  },

  mounted: function () {
    this.startLaunch();
  },
  methods: {
    onRetry () {
      this.error = null;
      this.startLaunch();
    },
    startLaunch () {
      let vue = this;
      let url =
        process.env.NODE_ENV === "production"
          ? "/launch/"
          : "http://localhost:8092/launch/";

      fetch(url + this.getUrlParameter("token"))
        .then(response => {
          console.log("response token:", response);
          if (response.ok) {
            return response.json();
          } else if (response.status >= 400 && response.status <= 410) {
            return { code: response.status, message: response.text() };
          }
        })
        .then(json => {
          if (json.code == 401) {
            vue.error = {
              reason: "Registration token expired.",
              message: "Please reregister."
            };
          } else if (json.code >= 400) {
            console.log("error:", json);
            vue.error = {
              reason: "Registration not available",
              code: "2103",
              retry: true,
              message:
                "We are sorry. Our domain registration service is currently not available. Please try again in a moment."
            };
          } else {
            vue.connectStatusSocket(json.statusUri, json.domain);
          }
        })
        .catch(function (response) {
          console.log("error:", response);
          vue.error = {
            reason: "No connection to launcher service possible.",
            code: "2102",
            message: "We are sorry. Our domain registration service is currently not available. Please try again in a moment.",
            retry: true
          };
        });
    }
    ,
    connectStatusSocket (statusUri, domain) {
      let vue = this;
      vue.domain = domain;


      this.socket = new WebSocketClient();
      console.log("open " + statusUri + "  for " + domain);
      this.socket.open(statusUri);

      this.progress = 5;
      this.socket.onmessage = ({ data }) => {
        console.log("ws message", data);
        this.progress += 10;
        var message = JSON.parse(data);
        vue.events.push(message);
        vue.currentEvent = message;
        if (
          message.statusMessage == "SUCCESS" ||
          message.statusMessage == "EXISTS"
        ) {
          this.progress = 100;
          vue.forwardurl = "https://" + vue.domain + ".webmo.online";
          this.fetchRetry(vue.forwardurl + "/health.php", (attempt) => console.log("try to get positive healthcheck", attemp))
            .then(() => {
              window.location = vue.forwardurl;
            })
            .catch(() => {
              vue.error = {
                reason: "-",
                code: "-",
                message: "Something went wrong. Your Webmo could not be reached. Please contact our support."
              };
            });
        } else if (message.statusMessage == "FAIL") {
          vue.error = {
            reason: message.data.error + " (" + message.data.rootCause + ")",
            code: "2101",
            message: "Setting up the your webmo environment failed, please retry.",
            retry: true
          };
        }
      };

      this.socket.onclose = ({ event }) => {
        /*   dbstatus = JSON.parse(data);
        var container = document.getElementById('container');
        var paragraph = document.createElement('p');
        paragraph.innerHTML = 'FINISHED';
        container.appendChild(paragraph);
      */
      };
    },
    disconnect () {
      this.socket.close();
      this.status = "disconnected";
      this.logs = [];
    },
    getUrlParameter (name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    async fetchRetry (url, attempts) {
      const self = this;
      let attempts_left = attempts;
      const _fetchRetry = async (url, attempt, callback) => {
        if (typeof callback == 'function') callback(attempt);
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error("Invalid response.");
          }
          return response;
        } catch (error) {
          if (attempt <= 1) {
            throw error;
          }
          await self.sleep(500);
          return _fetchRetry(url, attempt - 1);
        }
      };
      return await _fetchRetry(url, attempts_left);
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
};
</script>


<style lang="scss">
.page-wrapper {
  max-width: 1680px;
  margin: 0 auto;
  background-color: #fff;
  background-image: linear-gradient(180deg, rgba(219, 228, 231, 0), #dbe4e7);

  // sticky footer
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  // sticky footer
  flex-grow: 1;
}
#launcher {
  min-width: 80%;
}
footer {
  // sticky footer
  flex-shrink: 0;
}

.events {
  text-align: center;
}

.event {
  margin: 1rem 0;
}

.active {
  font-size: 120%;
  font-weight: bold;
}
</style>
